import React from 'react';
import Layout from '../components/Layout';
import YourCommunities from '../UI-Components/YourCommunities/YourCommunities';
import '../css/CommunityPage.css';
import NewCommunities from '../UI-Components/NewCommunities/NewCommunities';
import WhyCommunity from '../UI-Components/WhyCommunity/WhyCommunity';

const CommunityPage = () => {
  return (
    <Layout pageTitle="Home" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="copyright-header">
        © Copyright | All rights reserved | Joynet 2025
      </div>
      <YourCommunities />
      <div className="rounded-componentHome rounded-component-margin" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
        <div className="content-container">
          <div className="welcome-container">
            <span className='welcome-line1'>Welcome to The</span>
            <br />
            <span className='welcome-line2'>JoyNet Communities</span>
          </div>
          <div className="welcome-subline-container">
            <p className='welcome-subline-text'>
              Welcome to Your Circle of Support - Discover groups that resonate with your heart. In 'My Community', find your place to belong, share, and grow.
            </p>
          </div>
        </div>
      </div>
      <NewCommunities />
      <WhyCommunity />
    </Layout>
  );
};

export default CommunityPage;
